import { useState, useEffect } from "react";
import { MessageCircle, Phone, CheckCircle, TrendingUp, Target, Shield, Play } from "lucide-react";
import { getCampaignQuota } from "@/lib/campaign";

const HeroSection = () => {
  const [quota, setQuota] = useState(5);
  
  useEffect(() => {
    setQuota(getCampaignQuota());
  }, []);
  const whatsappNumber = "905326369115";
  const phoneNumber = "05326369115";
  const whatsappMessage = encodeURIComponent("Merhaba, Google Ads reklam yönetimi hizmetiniz hakkında bilgi almak istiyorum.");
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#012f23] via-[#024238] to-[#059669] opacity-95"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Sağ İçerik - Premium Profil Showcase (Mobilde ÜSTTE) */}
          <div className="space-y-6 order-1 lg:order-2">
            {/* Büyük Premium Portre Kartı */}
            <div className="relative rounded-3xl overflow-hidden border-2 border-[#FFD700]/60 shadow-[0_0_60px_rgba(255,215,0,0.25)] bg-gradient-to-br from-[#012f23] to-[#024238]">
              <div className="relative aspect-[4/5] w-full">
                <img
                  src="/images/dijital-mustafa-profil.webp"
                  alt="Dijital Mustafa - Google Reklam Uzmanı & Google Partner"
                  width="720"
                  height="900"
                  className="absolute inset-0 w-full h-full object-cover object-top"
                  loading="eager"
                  fetchPriority="high"
                  decoding="async"
                />

                <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-[#012f23]/80 via-[#012f23]/30 to-transparent"></div>

                {/* Sol Üst: Google Partner Badge */}
                <div className="absolute top-4 left-4 flex items-center gap-2 bg-white/95 backdrop-blur-sm rounded-xl px-3 py-2 shadow-xl border-2 border-[#FFD700]">
                  <img
                    src="/images/google-partner-badge.webp"
                    alt="Google Partner"
                    width="40"
                    height="40"
                    className="h-10 w-auto"
                    loading="eager"
                    decoding="async"
                  />
                  <div className="leading-tight">
                    <p className="text-[10px] font-bold text-gray-600 uppercase tracking-wide">Sertifikalı</p>
                    <p className="text-sm font-black text-[#012f23]">Google Partner</p>
                  </div>
                </div>

                {/* Sağ Üst */}
                <div className="absolute top-4 right-4 flex flex-col items-end gap-2">
                  <div className="bg-[#FFD700] text-[#012f23] px-3 py-1.5 rounded-lg font-black text-xs shadow-xl">
                    ⭐ 4.9/5.0
                  </div>
                  <div className="bg-[#012f23]/90 backdrop-blur-sm border border-[#FFD700]/50 text-white px-3 py-1.5 rounded-lg font-bold text-xs shadow-xl">
                    🏆 2007'den beri
                  </div>
                </div>

                {/* Alt isim plakası */}
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#012f23] via-[#012f23]/90 to-transparent pt-20 pb-5 px-6">
                  <p className="text-[#25D366] text-xs font-bold tracking-widest uppercase mb-1">
                    GOOGLE ADS REKLAM UZMANI
                  </p>
                  <h2 className="text-3xl md:text-4xl font-black text-white leading-tight mb-2">
                    Dijital <span className="text-[#FFD700]">Mustafa</span>
                  </h2>
                  <p className="text-sm text-gray-200 leading-snug">
                    18 yıllık deneyim · Google Ads Partner · Her projeyi <span className="text-[#FFD700] font-bold">bizzat ben</span> yönetiyorum
                  </p>
                </div>
              </div>

              {/* Google Partner Doğrulama Butonu */}
              <a
                href="https://www.google.com/partners/agency?id=6479203352"
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center justify-between gap-3 px-5 py-4 bg-gradient-to-r from-[#1a73e8] via-[#4285F4] to-[#1a73e8] hover:from-[#0d5fcc] hover:to-[#0d5fcc] transition-all"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center shadow-lg flex-shrink-0">
                    <span className="text-xl font-black bg-gradient-to-br from-[#4285F4] via-[#EA4335] to-[#FBBC04] bg-clip-text text-transparent">G</span>
                  </div>
                  <div className="text-left">
                    <p className="text-[10px] text-blue-100 font-bold uppercase tracking-wide">Google Onaylı</p>
                    <p className="text-sm md:text-base font-black text-white leading-tight">Google Ads Partner İş Ortağı Profilimi Görüntüle</p>
                  </div>
                </div>
                <span className="text-white text-xl group-hover:translate-x-1 transition-transform flex-shrink-0">→</span>
              </a>
            </div>
          </div>

          {/* Sol İçerik - Metin (Mobilde ALTTA) */}
          <div className="text-white space-y-6 order-2 lg:order-1">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-black leading-tight mb-2">
              <span className="text-[#25D366]">Google Reklam Ajansı</span>
              <span className="block text-3xl md:text-4xl lg:text-5xl text-white mt-2">Dijital Mustafa</span>
            </h1>

            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight">
              Google Ads Uzmanı &amp; Google Ads Danışmanlığı
            </h2>

            <p className="text-lg md:text-xl font-bold text-[#FFD700]">
              Google Ads Reklam Uzmanı · Google Partner sertifikalı · 2007'den beri
            </p>

            {/* Kanonik SEO cümlesi - sitenin tamamında aynı şekilde geçiyor */}
            <p className="text-base md:text-lg text-gray-200 leading-relaxed">
              <strong className="text-white">Google Reklam Ajansı Dijital Mustafa</strong> — <strong className="text-[#FFD700]">Google Ads Uzmanı</strong> olarak 18 yıllık <strong className="text-[#FFD700]">Google Ads danışmanlığı</strong> deneyimimle <strong className="text-[#FFD700]">Google Ads reklam uzmanı</strong> hizmeti sunuyorum. Google Partner sertifikalı profesyonel kampanya yönetimi.
            </p>

            {/* 15 Dakika Ücretsiz Görüşme Vurgusu */}
            <div className="flex items-center gap-3 bg-[#FFD700]/15 backdrop-blur-sm rounded-xl px-5 py-3 border-2 border-[#FFD700]">
              <span className="text-2xl">⏱️</span>
              <p className="text-base md:text-lg font-bold text-white">
                <span className="text-[#FFD700]">15 dakika ücretsiz</span> ön görüşme — kampanyalarınızı analiz edelim
              </p>
            </div>

            {/* Faydalar */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="flex items-start gap-3">
                <div className="p-2 bg-red-600/30 rounded-lg border-2 border-red-500/50">
                  <Shield className="w-5 h-5 text-red-400" />
                </div>
                <div>
                  <p className="font-semibold text-white">🛡️ Sahte Tıklama Koruması</p>
                  <p className="text-sm text-red-300 font-bold">%80'e varan koruma ile bütçeniz güvende</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="p-2 bg-[#059669]/20 rounded-lg">
                  <CheckCircle className="w-5 h-5 text-[#25D366]" />
                </div>
                <div>
                  <p className="font-semibold text-white">18 Yıllık Deneyim</p>
                  <p className="text-sm text-gray-300">Google Partner statüsü · Maksimum ROI</p>
                </div>
              </div>
            </div>

            {/* CTA Butonları */}
            <div className="flex flex-col sm:flex-row gap-4 pt-2">
              <a 
                href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="relative flex items-center justify-center gap-3 px-6 py-3.5 bg-gradient-to-r from-[#25D366] to-[#128C7E] text-white rounded-lg font-bold text-base hover:from-[#128C7E] hover:to-[#25D366] transition-all overflow-visible"
              >
                <MessageCircle className="w-5 h-5" />
                <span>WhatsApp – Ücretsiz Danışmanlık</span>
                <span className="absolute -top-2 -right-2 bg-[#FFD700] text-[#0D4F3E] text-[9px] font-black px-2 py-0.5 rounded border border-[#0D4F3E]/20">ÜCRETSİZ</span>
              </a>
              
              <a 
                href={`tel:${phoneNumber}`}
                className="relative flex items-center justify-center gap-3 px-6 py-3.5 bg-gradient-to-r from-[#EF4444] to-[#DC2626] text-white rounded-lg font-bold text-base hover:from-[#DC2626] hover:to-[#EF4444] transition-all overflow-visible"
              >
                <Phone className="w-5 h-5" />
                <span>Hemen Ara</span>
                <span className="absolute -top-2 -right-2 bg-[#FFD700] text-[#0D4F3E] text-[9px] font-black px-2 py-0.5 rounded border border-[#0D4F3E]/20">ANINDA</span>
              </a>
            </div>

            {/* Aciliyet Mesajı */}
            <div className="relative overflow-hidden rounded-xl border-2 border-[#FFD700] bg-gradient-to-r from-amber-600/30 via-amber-500/20 to-amber-600/30 backdrop-blur-sm p-4">
              <div className="relative flex items-center justify-center gap-3">
                <span className="text-2xl">🔥</span>
                <p className="text-center text-base md:text-lg font-bold text-white leading-relaxed">
                  Bu ay <span className="text-[#FFD700] text-lg md:text-xl">sadece {quota} yeni firma</span> kabul ediyorum.
                  <span className="text-amber-200"> Kontenjan dolmadan</span> yerinizi ayırtın!
                </p>
                <span className="text-2xl">🔥</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default HeroSection;